import { ChatSender } from '@varo/graphql-schema-types';
import { CHAT_START_MSG } from 'features/chat/helpers/ChatEvent.helper';
import { useSendMessage } from 'features/chat/hooks/useSendMessage';
import { ChatContext } from 'features/chat/providers/ChatContextProvider';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Button from 'shared/components/vxl/Button/Button';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';
import theme from 'shared/styles/theme';

interface ChatStartProps {
  setShowSnackbar: (showSnackBar: boolean) => void;
}

const ChatStart = ({ setShowSnackbar }: ChatStartProps) => {
  const { bottom } = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('chatStrings', {
    keyPrefix: 'banner',
  });
  const { isFeatureEnabled } = useStatsig();
  const isDecagonChatEnabled = isFeatureEnabled(
    FeatureFlagKey.ENABLE_DECAGON_CHAT,
  );
  const { isChatStarted, chatSessionId, setIsChatEndedFromEvent } =
    useContext(ChatContext);

  const { sendCustomerMessage, sendMessageFetching } =
    useSendMessage(setShowSnackbar);

  const handleStartChat = () => {
    void sendCustomerMessage(
      CHAT_START_MSG,
      ChatSender.User,
      isDecagonChatEnabled,
    );
    setIsChatEndedFromEvent(false);
  };

  return !isChatStarted ? (
    <View style={[styles.buttonWrapper, { paddingBottom: bottom }]}>
      <Button
        label={translatedText('buttonLabel')}
        onPress={handleStartChat}
        isLoading={sendMessageFetching}
        analyticsId="startChatClicked"
        customAttributes={{ chat_session_id: chatSessionId }}
      />
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  buttonWrapper: {
    padding: theme.spacing.m,
  },
});

export default ChatStart;
